import React from 'react';
import HintPopover from "../../hint-popover/hint-popover"
import ProjectSession from "../../../model2/project/project-session"
import MoreProject_Popover from "./popover";
import {MoreButtonType} from "../types";
import ControlButtonStandard, {
    ControlButtonType
} from "../../../gd-components/buttons/control-button/control-button-standard";


type Props = {
    className?      : string
    style?          : any

    hint?           : string
    project         : ProjectSession
    buttonType      : MoreButtonType
    onTogglePopover?: func
}

type State = {
    showPopover : boolean
}

export default class MoreButton_Project extends React.Component<Props, State> {

    constructor(props:Props) {
        super(props)

        this.state = {
            showPopover: false
        }
    }

    showPopover = (e: React.MouseEvent) => {
        if (e) e.stopPropagation()

        this.setState({
            showPopover: true
        }, ()=>{
            this.props.onTogglePopover && this.props.onTogglePopover(true)
        })
    }

    onClickActions = (e:React.SyntheticEvent) => {
        e.stopPropagation()
        const newValue = !this.state.showPopover;

        this.setState(
            {showPopover: newValue},
            ()=>{
                if (this.props.onTogglePopover) this.props.onTogglePopover(newValue);
            }
        )
    }

    hidePopover = (e: React.MouseEvent) => {

        if (!this.state.showPopover) return;

        this.setState({showPopover: false},
            ()=>{if (this.props.onTogglePopover) this.props.onTogglePopover(false);});
    }

    renderUI5() {

        const classes = Classes("btn", "i5-more", "s-18", this.props.className, {
            "show-popover": this.state.showPopover
        });

        return (
            <div className={classes} onClick={this.onClickActions}>

                {this.state.showPopover &&
                    <MoreProject_Popover hidePopover             = {this.hidePopover}
                                         project                 = {this.props.project}
                                         outsideClickIgnoreClass = "color-with-icon"
                                         parent                  = {this} />
                }

                {!this.state.showPopover && this.props.hint && <HintPopover parent={this} hint={this.props.hint} />}
            </div>
        );
    }

    renderControlButtonS24() {

        const hint = !this.state.showPopover ? this.props.hint : undefined

        const classes = Classes("more-button", this.props.className, {
            "show-popover": this.state.showPopover
        });

        return (
            <ControlButtonStandard type={ControlButtonType.MORE} size={24} onClick={this.onClickActions} hint={hint} className={classes} style={this.props.style}>

                {this.state.showPopover &&
                    <MoreProject_Popover hidePopover             = {this.hidePopover}
                                         project                 = {this.props.project}
                                         outsideClickIgnoreClass = "color-with-icon"
                                         parent                  = {this} />
                }
            </ControlButtonStandard>
        );
    }

    renderControlButtonS28() {

        const hint = !this.state.showPopover ? this.props.hint : undefined

        const classes = Classes("more-button", this.props.className, {
            "show-popover": this.state.showPopover
        });

        return (
            <ControlButtonStandard type={ControlButtonType.MORE} size={28} onClick={this.onClickActions} hint={hint} className={classes} style={this.props.style}>
                {this.state.showPopover &&
                    <MoreProject_Popover hidePopover             = {this.hidePopover}
                                         project                 = {this.props.project}
                                         outsideClickIgnoreClass = "color-with-icon"
                                         parent                  = {this} />
                }
            </ControlButtonStandard>
        )
    }

    render() {

        switch (this.props.buttonType) {
            case MoreButtonType.CONTROL_BUTTON_S28:
                return this.renderControlButtonS28()

            case MoreButtonType.CONTROL_BUTTON_S24:
            default:
                return this.renderControlButtonS24()

        }
    }
}
